import React from "react";
import { FluentProvider, teamsLightTheme } from "@fluentui/react-components";
import "./App.css";
import WelcomeContainer from "./Containers/WelcomeContainer";
import InitContainer from "./Containers/InitContainer";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

function App() {

  return (
    <>
    
      <FluentProvider theme={teamsLightTheme}>
        <AuthenticatedTemplate>
          <InitContainer />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <WelcomeContainer />
        </UnauthenticatedTemplate>
      </FluentProvider>
    </>
  );
}

export default App;
